import { useEffect, useState } from "react";
import axios from "@/api/api";
import { API_ROUTES } from "@/api/routes";

export function useProductos() {
  const [productos, setProductos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const { data } = await axios.get(API_ROUTES.productosList, {
          withCredentials: true,
        });
        setProductos(Array.isArray(data) ? data : []);
      } catch (e) {
        setErr(
          e?.response?.data?.message ||
            e?.message ||
            "No se pudieron cargar productos"
        );
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return { productos, loading, err };
}
